<template>
  <div class="bg-background flex min-h-screen items-center justify-center">
    <div class="max-w-md p-8 text-center">
      <i class="icon-lock text-error mb-4 text-6xl" />
      <h1 class="text-text mb-4 text-3xl font-semibold">{{ t('auth.notAllowed.inactiveTitle') }}</h1>
      <p class="text-text-secondary mb-8">{{ t('auth.notAllowed.inactiveMessage') }}</p>

      <div class="flex justify-center">
        <div class="flex flex-col gap-2">
          <InfuseButton @click="logout">
            {{ t('auth.notAllowed.logout') }}
          </InfuseButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useAuthenticator } from '@infuse/auth/services';
import { useCurrentUserStore } from '@infuse/iam/user/store';
import { InfuseButton } from '@infuse/ui/components';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

const { t } = useI18n();
const router = useRouter();
const authenticator = useAuthenticator();
const currentUserStore = useCurrentUserStore();

async function logout() {
  await authenticator.logout();
  currentUserStore.reset();
  await router.push({ name: 'auth-login' });
}
</script>
